var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3582 3C20.2583 2.99996 20.1598 3.02317 20.0705 3.0678L15.199 5.5042L9.69046 3.0556C9.68145 3.05175 9.67117 3.05108 9.66153 3.04723C9.63674 3.03797 9.61139 3.03025 9.58567 3.02411C9.56009 3.01721 9.5341 3.01183 9.50788 3.00802C9.45568 3.00373 9.40321 3.00373 9.35104 3.00802C9.32482 3.01183 9.29883 3.01721 9.27326 3.02411C9.24753 3.03025 9.22218 3.03797 9.1974 3.04723C9.18775 3.05108 9.17747 3.05172 9.16847 3.0556L3.38284 5.627C3.15059 5.73013 3.00094 5.96043 3.00098 6.21453V20.3572C3.00109 20.5747 3.11111 20.7774 3.29346 20.8959C3.47584 21.0146 3.70587 21.033 3.90479 20.9447L9.42942 18.4891L14.9541 20.9447C14.9637 20.9486 14.974 20.9447 14.9836 20.9505C15.1393 21.0202 15.3179 21.0162 15.4702 20.9396C15.4805 20.9351 15.4921 20.9396 15.5024 20.9325L20.6451 18.3611C20.8631 18.2522 21.0007 18.0294 21.0006 17.7858V3.64316C21.0009 3.28811 20.7132 3.00015 20.3582 3ZM8.7866 17.3679L4.28666 19.3678V6.6324L8.7866 4.63248V17.3679ZM14.5722 19.3678L10.0723 17.3679V4.63248L14.5722 6.63236V19.3678ZM19.715 17.3885L15.8579 19.317V6.6118L19.715 4.68326V17.3885Z",
    fill: "#1B1B1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapView);
export default __webpack_public_path__ + "static/media/map-view.1ea6d6d34ac9af93a5d6cd777f0b3fd8.svg";
export { ForwardRef as ReactComponent };